import { render, staticRenderFns } from "./ComplianceWarningModal.vue?vue&type=template&id=cc021bb4"
import script from "./ComplianceWarningModal.vue?vue&type=script&lang=js"
export * from "./ComplianceWarningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports